module.exports = __webpack_public_path__ + "img/dark-green-circle-table-6.ca8a42d1.png";